// These are avatar background colors, always under white initials (see
// _text-avatar.scss), so each one has to clear WCAG AA 4.5:1 against #ffffff.
// Five originally did not: #009292 (3.80), #936F6F (4.43), #B66DFF (3.17),
// #DB6D00 (3.39) and #EB2424 (4.37). Since getUserColor picks by hashing the
// user ID, roughly a third of users were getting unreadable initials.
//
// The five are darkened along their own hue so the palette stays recognisable,
// and to ~4.6 rather than exactly 4.5 so rounding cannot push them back under.
// Anything added here needs the same check.
export const USER_COLORS = [
  "#008282",
  "#CE2B7C",
  "#8F6C6C",
  "#006EDB",
  "#9358CF",
  "#35516C",
  "#920000",
  "#924900",
  "#B75B00",
  "#8012A1",
  "#E42323",
  "#298321",
  "#425510",
  "#676767",
  "#0F3D8C",
  "#39534E"
] as const
